export const separateParagraphs = (lines) => {
  const filteredLines = lines.filter((line) => line.length > 0);

  return filteredLines.join(`
`);
};
